import type { EventsWidgetActions } from 'src/store/actions/widgets/events';
import type { EventsWidgetViewModel, WidgetTabViewModel } from 'src/store/types';

export const eventsReducer = (
    state: WidgetTabViewModel<EventsWidgetViewModel>,
    action: EventsWidgetActions,
): WidgetTabViewModel<EventsWidgetViewModel> => {
    switch (action.type) {
        case 'userSetEventsColumns':
            return { ...state, widget: { ...state.widget, columns: action.columns } };
        case 'userSetEventsUniverse': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    universeId: action.universeId,
                },
            };
        }

        case 'userSetEventsEventTypes': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    eventTypes: action.eventTypes,
                },
            };
        }

        case 'userSetEventsGoToDate': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    gotoDate: action.date,
                },
            };
        }

        case 'updateEventsSymbolFilter':
        case 'userSetEventsSymbolFilter': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    symbolFilter: action.symbol,
                },
            };
        }

        case 'userSetEventsSymbolRetention': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    symbolRetention: action.symbolRetention,
                },
            };
        }

        case 'userSetEventsSlowIdeaId': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    slowIdeaId: action.slowIdeaId,
                },
            };
        }

        case 'userSetEventsFastIdeaIds': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    fastIdeaIds: action.fastIdeaIds,
                },
            };
        }

        case 'userSetEventsDisplayingCalendar': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    displayingCalendar: action.displayingCalendar,
                },
            };
        }

        case 'userSetEventsSplitPercentage': {
            const splitPercentage = Number.isFinite(action.splitPercentage)
                ? Math.min(100, Math.max(0, action.splitPercentage))
                : 50;
            return {
                ...state,
                widget: {
                    ...state.widget,
                    splitPercentage,
                },
            };
        }

        default:
            return state;
    }
};
